import React from 'react';
import styled from 'styled-components';
import { MonitoringData } from '@indigo-ag/schema';
import { SmallTitle, SmallBody, Card, palettes } from '@indigo-ag/component-module';
import i18next from 'i18next';
import { parseNumberToLocale } from 'shared';
import { v4 as uuidv4 } from 'uuid';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem 0;
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
`;

const CardContent = styled.div`
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.275rem;
  p {
    margin: 0 !important;
    color: ${palettes.brand.gray[800]};
  }
`;

interface DeforestationMonitoringDataListProps {
  title: string;
  monitoringDataList: MonitoringData[];
}
// TODO: Check if we need to add the restriction field
// const getRestrictionText = (restriction?: boolean) => {
//   return restriction
//     ? i18next.t('deforestationMonitoringDataCard-restriction-yes')
//     : i18next.t('deforestationMonitoringDataCard-restriction-no');
// };

const getOverlapPercentText = (overlapPercent?: number) => {
  if (!overlapPercent) return '-';
  if (overlapPercent === 0) return '0%';
  return (overlapPercent / 100).toLocaleString(window.navigator.language, {
    style: 'percent',
    minimumFractionDigits: 2
  });
};

export const DeforestationMonitoringDataList: React.FC<DeforestationMonitoringDataListProps> = ({
  title,
  monitoringDataList
}) => {
  return (
    <Container>
      <SmallTitle style={{ textTransform: 'uppercase' }}>{title}</SmallTitle>
      <CardsContainer>
        {monitoringDataList.map(({ year, area, overlapPercent, restriction, criticalityRestriction }, index) => (
          <Card key={uuidv4()}>
            <CardContent>
              <SmallBody>
                {i18next.t('deforestationMonitoringDataCard-year')}: {year ?? '-'}
              </SmallBody>
              <SmallBody>
                {i18next.t('deforestationMonitoringDataCard-area')} (ha): {area ? parseNumberToLocale(area) : '-'}
              </SmallBody>
              <SmallBody>
                {i18next.t('deforestationMonitoringDataCard-overlapPercent')}: {getOverlapPercentText(overlapPercent)}
              </SmallBody>
              <SmallBody>
                {i18next.t('deforestationMonitoringDataCard-criticalityRestriction')}: {criticalityRestriction ?? '-'}
              </SmallBody>
              {/* TODO: Checar necessidade de mostrar essa informação 
              <SmallBody>
                {i18next.t('deforestationMonitoringDataCard-restriction')}: {getRestrictionText(restriction)}
              </SmallBody>*/}
            </CardContent>
          </Card>
        ))}
      </CardsContainer>
    </Container>
  );
};

export default DeforestationMonitoringDataList;
